module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n\r\n    #propMainGridButtons button{\r\n        width: 56px!important;\r\n    }\r\n</style>\r\n\r\n<div class=\"prop-header\"><span class=\"prop-label\">Data Sources</span></div>\r\n\r\n\r\n<div class=\"row format-table-sources\" style=\"padding-left: 0; height: 115px;\">\r\n    <table id=\"propMainTable\"></table>\r\n</div>\r\n<div id=\"propMainGridButtons\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 pf-btn-no-padding nopadding-l\">\r\n            <button class=\"btn btn-default\" id=\"New\">New</button>\r\n            <button class=\"btn btn-default\" id=\"Edit\"  disabled>Edit</button>\r\n            <button class=\"btn btn-default\" id=\"Duplicate\" disabled>Duplicate</button>\r\n            <button class=\"btn btn-default\" id=\"Remove\" disabled>Remove</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}